export class Pedido {
    ID!:number
    fecha !: Date
    id_aficionado !: number
    direccion !: string
    poblacion !: string
    codigo_postal !: string
    estado !: string
    precio_total !: number
}
